<template>
  <div class="subject-list-section">
    <!--layout1 1课程 -->
    <div class="subject-list-section-box" @click="go_course(dataItem)">
      <div class="subject-list-section-left">
        <van-image class="subject-list-section-left-img" fit="cover" :src="dataItem.cover_img" />
        <img
            v-if="dataItem.type == 2"
            class="subject-list-section-left-zl"
            src="/static/v4/icon_list_tag_column.svg"
            alt=""
        />
      </div>
      <div class="subject-list-section-right">
        <div class="subject-list-section-right-title">{{ dataItem.title }}</div>
        <div class="subject-list-section-right-detail" v-if="dataItem.type == 2">
          共{{ dataItem.total_count }}{{ dataItem.source_type == 0 ? '节' : '期'}}  <span style="margin-left: 8px">{{ dataItem.view_count }}人观看</span>
        </div>
        <div class="subject-list-section-right-detail" v-else>
          <span>{{ dataItem.view_count }}人观看</span>
        </div>
      </div>
      <div class="clear"></div>
    </div>
  </div>
</template>

<script>
import Interface from '@/util/interface'
export default {
  name: "course",
  props: {
    dataItem: {
      type: Object,
      required: true
    },
    contentItem: {
      type: Object
    },
    wapperFn: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    go_course(item) {
      console.log('item====', item)
      this.$router.push({ name: 'course-column', params: { id: item.origin_id} })
      Interface.mFootPrint(item.origin_id,1,0,5,0, item.title)
    }
  }
}
</script>

<style scoped lang="scss">
.subject-list-section {
  &-box{
    display: flex;
    flex-direction: row;
    width: 331px;
    position: relative;
    margin: 0 auto;
    padding-top: 16px;
    padding-bottom: 16px;
    border-bottom: 1px solid #F2F2F2;
  }
  .last{
    border-bottom-width: 0px;
  }
  &-left{
    width: 140px;
    position: relative;
    border-radius: 6px;
    
    &-img{
      width: 130px;
      height: 72px;
      background: #EFF3FA;
      border-radius: 6px;
      img{
        border-radius: 6px;
      }
      /deep/ .van-image__img{
        border-radius: 6px;
      }
    }
    &-zl{
      position: absolute;
      top: 0;
      left: 0;
    }
    &-time{

      width: 100%;
      bottom: 0px;
      position: absolute;
      color: #fff;

      font-family: Avenir-Heavy;
      font-size: 11px;
      letter-spacing: 0;
      text-align: right;

      background-image: linear-gradient(180deg, rgba(255,255,255,0.00) 0%, rgba(0,0,0,0.40) 100%);
      border-radius:0 0 6px 6px;

      span{
        display: inline-block;
        margin-bottom: 4px;
        margin-right: 8px;
      }
    }
  }

  &-right{
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    &-title{
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 500;
      color: #222222;
      text-align: justify;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
      word-break: break-all;
      .light{
        color: #D81D33;
      }
    }
    &-author{
      font-family: PingFangSC-Regular;
      font-size: 14px;
      color: #404040;
      letter-spacing: 0;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
      word-break: break-all;
    }
    &-detail{
      display: flex;
      flex-direction: row;
      // justify-content: space-between;
      align-items: flex-start;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #9D9D9D;
      &-join{
        display: inline-block;
        font-family: PingFangSC-Medium;
        font-size: 13px;
        color: #D81D20;
        background: #FFF0EE;
        border-radius: 17px;
        padding: 5px 15px;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/hotRecommend/layout1/course.vue